import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=4f538b47&scoped=true"
import script from "./Pane.vue?vue&type=script&lang=js"
export * from "./Pane.vue?vue&type=script&lang=js"
import style0 from "./Pane.vue?vue&type=style&index=0&id=4f538b47&prod&lang=scss&scoped=true"
import style1 from "./Pane.vue?vue&type=style&index=1&id=4f538b47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f538b47",
  null
  
)

export default component.exports